import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { css } from 'emotion';
import { Container } from 'semantic-ui-react';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';

import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import { Row, Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';

export const shareButtonsStyle = props => css`
  color: ${props.theme.colors.primary} !important;
`;

export const shareLabelStyle = props => css`
  font-size: ${props.theme.fonts.sizes.xSmall}px;
`;

export const ShopImage = styled.img`
  width: ${props => props.theme.new.spacer * 14.5}px;
  height: ${props => props.theme.new.spacer * 14.5}px;
  position: relative;
  top: -${props => props.theme.new.spacer * 2.5}px;
  background-color: ${props => props.theme.colors.invertedLabels.important};
  border: solid ${props => props.theme.borders.size.thin}px
    ${props => props.theme.borders.color.lightGray};
  border-radius: ${props => props.theme.borders.radius.normal}px;
  object-fit: contain;
  ${props => cssMediaMax.tablet`
     width: ${props.theme.new.spacer * 12}px;
     height: ${props.theme.new.spacer * 12}px;
  `} ${props => cssMediaMax.mobile`
     width: ${props.theme.new.spacer * 7.5}px;
     height: ${props.theme.new.spacer * 7.5}px;
  `};
`;

export const ratingCountStyle = props => css`
  margin-left: ${props.theme.paddings.normal}px;
  color: ${props.theme.colors.labels.emphasized}!important;
  font-size: ${props.theme.fonts.sizes.medium - 0.5}px;
  ${cssMediaMax.xsmall`
    font-size: ${props.theme.fonts.sizes.xxSmall}px;
  `};
`;

export const HeaderContainer = styled.div`
  background-color: ${props => props.theme.colors.backgroundColor};
  padding-bottom: ${props => props.theme.paddings.xLarge}px;
`;

const ShopDetailsHeaderContainer = styled.div`
  width: auto;
`;

const ShopDetailsHeaderDesktop = props => (
  <HeaderContainer>
    <Container>
      <ShopDetailsHeaderContainer>
        <Row spaceBetweenJustified topAligned>
          <Row topAligned>
            {props.ShopLogo}
            <Spacer size={1.5} />
            <Column topAligned>
              {props.shopName}
              <React.Fragment>
                <Spacer size={1.5} />
                {props.Rating}
                <Spacer size={1} />
              </React.Fragment>
              {props.ShopAddress}
            </Column>
          </Row>
          <Row spaceBetween={1} topAligned>
            <Column>
              <Spacer size={2.2} />
              {props.shopInfoIcon}
            </Column>
            <Column>
              <Spacer size={2} />
              {props.actionButtons}
            </Column>
          </Row>
        </Row>
      </ShopDetailsHeaderContainer>
    </Container>
  </HeaderContainer>
);

ShopDetailsHeaderDesktop.defaultProps = {
  ShopAddress: null,
};

ShopDetailsHeaderDesktop.propTypes = {
  shopName: PropTypes.element.isRequired,
  Rating: PropTypes.element.isRequired,
  ShopAddress: PropTypes.element,
  ShopLogo: PropTypes.element.isRequired,
  actionButtons: PropTypes.element.isRequired,
  shopInfoIcon: PropTypes.element.isRequired,
};

export default withMedia(ShopDetailsHeaderDesktop);
